import React, { Component } from 'react';

class EditPublicidad extends Component {
    state = {  }
    render() { 
        return (
            <div>Editar Publicidad y Mercadeo</div>
        );
    }
}
 
export default EditPublicidad;


// WEBPACK FOOTER //
// ./src/views/WebMaster/EditPublicidad.jsx